import React from 'react';

import russelsmithLogo from '../../../assets/images/brand.png';
import classNames from './style.module.scss';

interface CustomSectionHeaderDetails {
    organizationLogo: string;
    organizationName: string;
    facilityLogo: string;
    facilityName: string;
}

const CustomSectionHeader: React.FC<CustomSectionHeaderDetails> = ({ organizationLogo, organizationName, facilityLogo, facilityName }) => {
    return ( 
        <div className={classNames.customSectionLogos}>
            <div>
                <img
                    src={organizationLogo}
                    alt={organizationName}
                    className={classNames.customSectionLogosItem}
                />
            </div>
            {facilityLogo ? (
                <div>
                    <img
                        src={facilityLogo}
                        alt={facilityName}
                        className={classNames.customSectionLogosItem}
                    />
                </div>
            ) : (
                <div className={classNames.customSectionFacilityName}>
                    {facilityName}
                </div>
            )}
            <div>
                <img
                    src={russelsmithLogo}
                    alt="Arridex"
                    className={classNames.customSectionLogosItem}
                />
            </div>
        </div>
     );
}
 
export default CustomSectionHeader;